module.exports = __webpack_public_path__ + "img/dep_bakery@3x.73f47d3d.png";